"use client";

import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface WebhookUrlStatusProps {
  message: ReactNode;
  tone?: "neutral" | "error";
  className?: string;
  textClassName?: string;
}

export function WebhookUrlStatus({ message, tone = "neutral", className, textClassName }: WebhookUrlStatusProps) {
  const isError = tone === "error";

  return (
    <div
      className={cn(
        "flex items-center gap-2 rounded-md border px-3 py-2",
        isError
          ? "border-red-200 bg-red-50 dark:border-red-700 dark:bg-red-900/20"
          : "border-ds-border-default dark:bg-ds-neutral-800 bg-zinc-50",
        className,
      )}
    >
      <code
        className={cn(
          "flex-1 truncate text-xs",
          isError ? "text-red-600 dark:text-red-400" : "label-xs",
          textClassName,
        )}
      >
        {message}
      </code>
    </div>
  );
}
